module.exports = new __parcel__URL__("machines_photon_shield_level_2.72329a8c.png").toString();